import React from 'react'
import DocumentTitle from 'react-document-title'

export default class Hiking extends React.Component {
	render() {
		return (
			<DocumentTitle title='Hiking'>
				<article className='content'>
					<h2 className='title'>Hiking</h2>
					<p>There are a <em>lot</em> of trails you can hike in the Tri-Cities. We&rsquo;ve curated a small list below, but you&rsquo;ll find much more detailed information on <a href='http://hiketricities.com/hikes/' title='Hike Tri-Cities'>the Hike Tri-Cities</a> website, which has a super detailed breakdown of the hikes available.</p>
					<ul>
						<li>
							<p><strong>Audubon Trail</strong> (Kennewick, easy)</p>
							<p>A short, one mile hike that offers great bird-watching opportunities.</p>
						</li>
						<li>
							<p><strong>Badger Mountain</strong> (Richland, moderate)</p>
							<p>A bit more challenging hike, it can vary in its distance. The Skyline trail trailhead is an easier start, with more gradual switchbacks. <strong>Warning: rattlesnakes have been sighted on this trail.</strong></p>
						</li>
						<li>
							<p><strong>Bateman Island</strong> (Richland, easy)</p>
							<p>An easier, 3-ish mile hike. Another great opportunity for bird watching.</p>
						</li>
						<li>
							<p><strong>Candy Mountain Trailhead</strong> (Richland, easy/moderate)</p>
							<p>Not the easiest hike, but still doable. Just over 3 miles long. <strong>Warning: rattlesnakes have been sighted on this trail.</strong></p>
						</li>
						<li>
							<p><strong>Freedom Trail</strong> (Kennewick, easy)</p>
						</li>
						<li>
							<p><strong>McNary Wildlife Refuge</strong> (Burbank, moderate)</p>
							<p>A somewhat challenging hike, you can park at the USFWS building and hike about a mile around the pond. <strong>Warning: rattlesnakes have been sighted on this trail.</strong></p>
						</li>
						<li>
							<p><strong>Richland Riverfront Trail</strong> (Richland, easy)</p>
							<p>Stretching almost 15 miles around Richland, the Richland Riverfront Trail is an urban trail that&rsquo;s more of a leisurely stroll through Richland than a hike. You can hop on the trail at Howard Amon Park, Leslie Groves Park, or near the PNNL Submarine monument.</p>
						</li>
						<li>
							<p><strong>Yakima River Delta</strong> (Richland, easy)</p>
						</li>
						<li>
							<p><strong>Zintel Canyon</strong> (Kennewick, easy)</p>
						</li>
					</ul>
				</article>
			</DocumentTitle>
		)
	}
}



// WEBPACK FOOTER //
// ./client/components/Hiking/index.jsx